import { ModalCreateEntity } from 'app/shared/components/modal-create-entity';
import React from 'react';

import { createEntity } from '../../material-source/material-source.reducer';

export const ModalMaterialSourceCreate = () => {
  return <ModalCreateEntity createEntity={createEntity} entityKey="materialSource" />;
};
